module.exports = __webpack_public_path__ + "static/media/background.d8a6bba1.png";